import { StatisticValueStatusEnum } from '../../enums/statistic-value-status.enum';

export interface IPerformanceRankingSchema {
    name: string;
    score: number;
    tripsCount: number;
    punctualityOnDestinationsLoading: string;
    punctualityOnDestinationsLoadingDiff?: number;
    punctualityOnDestinationsUnloading: string;
    punctualityOnDestinationsUnloadingDiff?: number;
    successfulDeliveriesRate: string | null;
    excessStayTimeLoading: string;
    excessStayTimeLoadingDiff: string | null;
    excessStayTimeLoadingDiffNumeric: number | null;
    excessStayTimeLoadingMinutes?: number;
    excessStayTimeUnloading: string;
    excessStayTimeUnloadingDiff: string | null;
    excessStayTimeUnloadingDiffNumeric: number | null;
    excessStayTimeUnloadingMinutes?: number;
    excessStayTimeTotalMinutes?: number;
    avgStayTimeLoading?: string;
    avgStayTimeUnloading?: string;
    rank: number;
    rankDiff?: number;
    scoreDiff?: number;
    participationRate: string;
    punctualityOnDestinationsStatus: StatisticValueStatusEnum;
    totalOrders: number | null;
    successfulDeliveriesRateStatus: StatisticValueStatusEnum | null;
}

export interface IParticipationDriver {
    name: string;
    score: number;
    participation: number;
    tripsCount: number;
}

export interface IParticipationCategory {
    quadrant: string;
    count: number;
    scoreThreshold: number;
    participationThreshold: number;
    drivers: IParticipationDriver[];
}

export interface IPerformanceRankingOutput {
    rankings: IPerformanceRankingSchema[];
    participationMatrix: IParticipationCategory[];
    totalTrips: number;
    totalCount: number;
    scoreFormula: string | null;
    sort?: string;
}
